

















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Asset } from "@foxone/api/src/models/defi";
import WithdrawAuditModal from "defi/components/partial/WithdrawAuditModal.vue";
import UnCompleteWithdrawModal from "defi/components/partial/UnCompleteWithdrawModal.vue";
import { ERROR } from "defi/constants";

export type WithdrawAction = (opts: { quantity: string }) => Promise<string>;

@Component({
  components: {
    WithdrawAuditModal,
    UnCompleteWithdrawModal
  }
})
class Withdraw extends Vue {
  @Prop({ type: String, default: "" }) contractId!: string;

  @Prop({ type: Number, default: 0 }) remain!: number;

  @Prop({ type: Number, default: 0 }) withdrawRatio!: number;

  @Prop({ type: Number, default: 0 }) withdrawAuditLimit!: number;

  @Prop({ type: Array, default: () => [] }) assets!: Asset[];

  @Prop({ type: Function }) action!: WithdrawAction;

  asset: any = null;

  amount = "";

  unCompleteWithdrawModal = false;

  withdrawAuditModal = false;

  loading = false;

  form: any = null;

  get rules() {
    const { remain } = this.meta;
    return [
      v =>
        Number(v) <= Number(remain) ||
        this.$t("common.amount.more-than-avalible")
    ];
  }

  get errorMessage() {
    const input = this.form?.inputs[0];
    return input?.errorBucket[0];
  }

  get meta() {
    const { remain, asset, withdrawRatio, amount, withdrawAuditLimit } = this;
    const symbol = asset?.symbol.toUpperCase();
    const assets = this.assets.map(x => ({
      id: x.id,
      symbol: x.symbol,
      name: x.name,
      logo: x.icon
    }));

    let fee = "";
    let feeVisible = false;
    if (withdrawRatio) {
      fee = (+withdrawRatio * +amount).toFixed(8);
      feeVisible = +amount > 0 && +withdrawRatio > 0;
    }
    const submitDisabled = this.errorMessage || !this.amount;

    return {
      remain,
      symbol,
      assets,
      submitDisabled,
      selectable: assets.length > 1,
      withdrawBtnText: this.$t("common.withdraw"),
      needAudit: withdrawAuditLimit >= 0,
      feeText:
        (feeVisible && this.$t("common.fee", { amount: `${fee} ${symbol}` })) ||
        ""
    };
  }

  mounted() {
    this.form = this.$refs.form as any;
    if (this.meta.assets.length > 0) {
      this.asset = this.meta.assets[0];
    }
  }

  handleWithdraw() {
    const form: any = this.$refs.form;
    const valid = form.validate();
    if (valid) {
      this.requestWithdraw();
    }
  }

  handleFillAomount(value) {
    this.amount = value;
  }

  handleBlur() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }

  async requestWithdraw() {
    if (!this.contractId) return;

    this.loading = true;
    const data = { quantity: this.amount };
    try {
      const { trace_id: traceId } = await this.$api.defi.requestWithdraw(
        this.contractId,
        data
      );
      if (this.meta.needAudit) {
        this.showAuditModal(traceId);
      } else {
        this.$common.utils.helper.toast(this, {
          message: this.$t("common.withdraw.request.success") as string,
          color: "success"
        });
        const transaction = await this.$api.defi.getTransactionByTraceId(
          traceId
        );
        this.toTransaction(transaction.id);
      }
    } catch (error) {
      if (error.code === ERROR.HAS_UNCOMPELTE_WITHDRAW) {
        this.unCompleteWithdrawModal = true;
        this.loading = false;
        return;
      }
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  toTransaction(id) {
    this.$helper.toFusionPath(this, "defi", {
      name: "transactions-id",
      params: { id }
    });
  }

  showAuditModal(traceId) {
    const modal: any = this.$refs.withdrawAuditModal;
    modal.show(traceId);
  }
}
export default Withdraw;
